export default __webpack_public_path__ + "static/media/Group 3453.f5e56e23.png";